module.exports = __webpack_public_path__ + "static/media/wyre.601f1a0d.jpg";